interface IApiPagination {
	page: number
	perPage: number
}

interface IApiSort {
	[key: string]: EApiSortType
}

interface IApiSimpleQueries {
	[key: string]: string | number | boolean | undefined
}

function applyFilterParams(query: Record<string, string | undefined>, filters: IApiFilters) {
	for (const key in filters) {
		if (!Object.hasOwn(filters, key)) continue
		const value = filters[key]
		if (Array.isArray(value)) {
			query[`filter[${key}]`] = value.join(',')
		} else if (value !== undefined && value !== null && value !== '') {
			query[`filter[${key}]`] = typeof value === 'string' ? value : `${value}`
		}
	}
}

function applySortParams(query: Record<string, string | undefined>, sort: IApiSort) {
	query.sort = Object.entries(sort)
		.map(([key, value]) => (value === EApiSortType.DESC ? `-${key}` : key))
		.join(',')
}

function applySimpleQueries(query: Record<string, string | undefined>, simpleQueries: IApiSimpleQueries) {
	for (const key in simpleQueries) {
		if (simpleQueries[key] === undefined) continue
		query[key] = simpleQueries[key]
	}
}

export const createQuery = (
	pagination?: IApiPagination | null,
	filters?: IApiFilters | null,
	sort?: IApiSort,
	simpleQueries?: IApiSimpleQueries,
) => {
	const query: Record<string, string | undefined> = {}
	if (pagination) {
		query['page[number]'] = `${pagination.page}`
		query['page[size]'] = `${pagination.perPage}`
	}
	if (filters) applyFilterParams(query, filters)
	if (sort) applySortParams(query, sort)
	if (simpleQueries) applySimpleQueries(query, simpleQueries)
	return { query }
}

const proxyPrefix = createApiRoute(ApiModule.PRODUCTION_PLANNING, ApiModule.EMPLOYEE, ApiDataModel.CRM)
export const createProxy = async <T>(request: string, options?: any) =>
	await apiCommon<T>(proxyPrefix, {
		method: 'POST',
		body: {
			method: 'GET',
			url: request,
			...options,
		},
	})
